import { showAlertCallout } from "@/shared/alerts";
import { toast } from "sonner";

interface AlertCalloutMessages {
  loading: {
    title: string;
    description?: string;
  };
  success: {
    title: string;
    description?: string;
  };
  error: {
    title: string;
    description?: string;
  };
}

export const alertCalloutPromise = async <T>(
  promise: Promise<T>,
  messages: AlertCalloutMessages,
) => {
  const alertCalloutId = showAlertCallout({
    type: "loading",
    ...messages.loading,
  });

  try {
    const result = await promise;

    toast.dismiss(alertCalloutId);

    showAlertCallout({
      type: "success",
      ...messages.success,
    });

    return result;
  } catch (error) {
    toast.dismiss(alertCalloutId);

    showAlertCallout({
      type: "critical",
      ...messages.error,
    });

    throw error;
  }
};
